import React from 'react';
import {
    CardContent,
    CardHeader,
    FormControl,
    Typography,
} from '@mui/material';
import TextFieldStyled from '../../shared/TextFieldStyled';
import PrimaryButton from '../../shared/Buttons/PrimaryButton';
import { useTranslation } from 'react-i18next';
import { SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import * as yup from 'yup';
import { ComponentsProps } from '../../../models/Admin/AdminProductsManagement';

const schema = yup.object().shape({
    content: yup.string().required('REQUIRED'),
});

export const AddProductsBySKUForm: React.FC<ComponentsProps> = (props) => {
    const { isLoading, formSubmit } = props;

    const { t } = useTranslation('admin', {
        keyPrefix: 'PRODUCTS_MANAGEMENT.PRODUCTS_BY_SKU',
    });

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<FormValues>({
        resolver: yupResolver(schema),
    });

    const onSubmit: SubmitHandler<FormValues> = (data) => {
        // TODO: SKU api
        console.log(data);
        formSubmit(data.content);
    };

    return (
        <>
            <CardHeader title={t('TITLE')} />
            <CardContent>
                <Typography paragraph>{t('CONTENT')}</Typography>
                <Typography paragraph>{t('AFTER_RUN')}</Typography>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <FormControl fullWidth>
                        <TextFieldStyled
                            label={t('LABEL')}
                            multiline
                            rows={4}
                            error={!!errors.content}
                            {...register('content')}
                            helperText={
                                errors.content
                                    ? t(errors.content.message).toString()
                                    : ' '
                            }
                        />
                    </FormControl>
                    <PrimaryButton type="submit" disabled={isLoading}>
                        {t('BUTTON')}
                    </PrimaryButton>
                </form>
            </CardContent>
        </>
    );
};

type FormValues = {
    content: string;
};
